module.exports = __webpack_public_path__ + "rotate-cw.svg?b6a9518cd8e8fe864a64e793206d0603";